<div class="bpp-selector-wrapper">
    <div class="bpp-selector-container"
         #selectorContainer
         (click)="toggleDropdown($event)"
         (keydown)="toggleDropdown($event)">
      <span class="selected-text signpost">{{ selected || 'Select option' }}</span>
      <mat-icon class="dropdown-icon"
                [ngClass]="{ 'open': isOpen }">
        keyboard_arrow_down
      </mat-icon>
    </div>
  
    <ng-template #dropdownTemplate>
      <div class="dropdown-list"
           [ngClass]="dropdownPosition">
        <div class="dropdown-item"
             *ngFor="let item of items"
             (click)="selectItem(item, $event)"
             (keydown)="selectItem(item, $event)">
          {{ item }}
        </div>
      </div>
    </ng-template>
  </div>